export const auth0Claims = {
  authorizationClaim: 'https://dashboard.vetavirtual.com/authorization',
  rolesClaim: 'dashboard.vetavirtual.com/roles',
  userAuthClaim: 'https://dashboard.vetavirtual.com/user_authorization',
}

export const defaultOrganization = 'Veta Virtual Mainline CA'

export const userRoles = {
  ADMINISTRATOR: 'Administrator',
}
